import React, { FC } from 'react';

import Button from '../../../../../../components/Button';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';
import { goToSeasonsSettings } from '../../Utils/goToSeasons';
import SetupNewSeasonModalStyled from './SetupNewSeasonModal.Styles';

interface IProps {
  displaySetupNewSeasonModal: boolean;
  toggleDisplaySetupNewSeasonModal: () => void;
}

const SetupNewSeasonModal: FC<IProps> = props => {
  const { displaySetupNewSeasonModal, toggleDisplaySetupNewSeasonModal } = props;

  const { clubId } = useRouteInfoState();

  return clubId ? (
    <SetupNewSeasonModalStyled
      id="club15-help-modal"
      open={displaySetupNewSeasonModal}
      onClose={toggleDisplaySetupNewSeasonModal}
      title="TIME TO START A NEW SEASON"
      text="Your previous season has been completed. Please extend the previous season or start a new season to add a new event."
      actions={[
        <Button
          key="button-cancel"
          onClick={toggleDisplaySetupNewSeasonModal}
          variant="outlined"
          color="primary"
          fullWidth={true}
        >
          NOT RIGHT NOW
        </Button>,
        <Button
          key="button-agree"
          onClick={goToSeasonsSettings(clubId)}
          variant="contained"
          color="primary"
          fullWidth={true}
        >
          SETUP A NEW SEASON
        </Button>
      ]}
    />
  ) : (
    <></>
  );
};

export default SetupNewSeasonModal;
